import {
	Store,
	combineReducers,
	createStore,
	applyMiddleware,
	compose,
} from 'redux';
import thunkMiddleware from 'redux-thunk';
import { $$store } from '@seeneco-ui/core/flux';
import { businessRootReducer, IBusinessState } from '@seeneco-ui/business';

import { sharedReducer, SharedState } from '@shared';
import { platformReducer, PlatformState } from '@platform';
import { leadsReducer, LeadsState } from '@leads';
import { statusReducer, StatusState } from '@status';


export interface IAppState {
	$business: IBusinessState;
	shared: SharedState;
	platform: PlatformState;
	leads: LeadsState;
	status: StatusState;
};

const REDUX_DEVTOOLS_EXTENSION = '__REDUX_DEVTOOLS_EXTENSION__';

const skipPromiseMiddleware = _ => next => action => !(action instanceof Promise) && next(action);

function configureStore(initialState): Store<IAppState> {
	const rootReducer = combineReducers<IAppState>({
		$business: businessRootReducer,
		shared: sharedReducer,
		platform: platformReducer,
		leads: leadsReducer,
		status: statusReducer,
	});
	const devTools = typeof window[REDUX_DEVTOOLS_EXTENSION] === 'function' ? window[REDUX_DEVTOOLS_EXTENSION]() : f => f;
	const enhancers = compose(
		applyMiddleware(
			thunkMiddleware,
			skipPromiseMiddleware,
		),
		devTools
	);

	return createStore(rootReducer, initialState, enhancers);
}

const store = configureStore({});

window[$$store] = store;

export {
	store,
};
